import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotificationRecipient } from '../../../../projects/client';

import { NotificationsActions } from './notifications.actions';
import { NotificationsSelectors } from './notifications.selectors';

@Injectable({ providedIn: 'root' })
export class NotificationsStore {
  email$ = this.store.select(NotificationsSelectors.getEmail());
  loading$ = this.store.select(NotificationsSelectors.isLoading());
  loaded$ = this.store.select(NotificationsSelectors.isLoaded());
  notificationsEnabled$ = this.store.select(NotificationsSelectors.notificationsEnabled());

  centralEmail$ = this.store.select(NotificationsSelectors.getCentralEmail);
  centralEmailStatus$ = this.store.select(NotificationsSelectors.getCentralMailStatus);
  notificationRecipients$ = this.store.select(NotificationsSelectors.getNotificationRecipients);
  notificationRecipientsStatus$ = this.store.select(
    NotificationsSelectors.getNotificationRecipientsStatus
  );

  constructor(private store: Store) {}

  // CENTRAL EMAIL

  getCentralEmail(): void {
    this.store.dispatch(NotificationsActions.getCentralEmail());
  }

  setCentralEmail(email: string): void {
    this.store.dispatch(NotificationsActions.setCentralEmail({ email }));
  }

  updateCentralEmail(email: string): void {
    this.store.dispatch(NotificationsActions.updateCentralEmail({ email }));
  }

  deleteCentralEmail(): void {
    this.store.dispatch(NotificationsActions.deleteCentralEmail());
  }

  // NOTIFICATION RECIPIENTS

  getNotificationRecipients(): void {
    this.store.dispatch(NotificationsActions.getNotificationRecipients());
  }

  updateNotificationRecipient(isActive: boolean, recipient: NotificationRecipient): void {
    this.store.dispatch(NotificationsActions.updateNotificationRecipient({ isActive, recipient }));
  }

  // MAIL SUBSCRIPTIONS

  getMailSubscription(): void {
    this.store.dispatch(NotificationsActions.getMailSubscription());
  }

  setMailSubscription(isActive: boolean): void {
    this.store.dispatch(NotificationsActions.setMailSubscription({ notifications: isActive }));
  }
}
